import colors from "styles/colors";

export const selectCustomStyles = {
  option: (provided, state) => ({
    ...provided,
    border: "none",
    borderRadius: "4px",
    background: state.isSelected ? "#dff0ff" : `${colors.white}`,
    color: state.isSelected ? `${colors.blue}` : `${colors.mud}`,
    display: "flex",
    alignItems: "center"
  }),
  control: (base, state) => ({
    ...base,
    border: "none",
    borderRadius: "2px",
    background: "#dff0ff",
    height: "42px"
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    flexWrap: "unset",
    paddingLeft: "0"
  }),
  indicatorSeparator: (styles) => {
    return { ...styles, display: "none" };
  },
  dropdownIndicator: (styles) => {
    return { ...styles, color: `${colors.mud}` };
  }
};
